/* eslint-disable react/no-array-index-key */
import React from 'react';
import { FiMenu } from 'react-icons/fi';
import { useHistory } from 'react-router';

import { ProcessButton, standards } from '../../../../../components';

function useQRCode(commands) {
  const history = useHistory();

  const goToOrders = (space) => history.push({
    pathname: '/orders',
    state: { nextPath: `/${space.nickname}` },
  });
  
  return ({
    eventHandlers: {
      goToOrders
    },
    localStates: {

    },
  });
}

export default function QRCode(props) {
  const { commands, sharedStates } = props;
  const { localStates, eventHandlers } = useQRCode(commands);
  
  return (
    <ProcessButton
      Icon={<FiMenu size={24} color="#fff" />}
      style={{ backgroundColor: standards.colors.orange.medium, alignSelf:'center'}}
      text="Ver meus pedidos"
      action={()=>eventHandlers.goToOrders(sharedStates.space)}
    />
  );
}
